import * as Dictionary from './tokens';

export const SageDictionary = Dictionary;
